
export function toCents(dollars: number | null): number {
  return (dollars || 0) * 100;
}

export function toDollars(cents: number): number {
  return +((cents || 0) / 100).toFixed(2);
}

export function subtractDollars(first: number | null, second: number | null): number {
  return toDollars(toCents(first) - toCents(second));
}

export function addDollars(first: number | null, second: number | null): number {
  return toDollars(toCents(first) + toCents(second));
}

export function multiplyDollars(dollars: number | null, quantity: number) {
  return toDollars(toCents(dollars) * quantity);
}

export function sumDollars(dollars: number[]): number {
  return dollars.reduce((sum, item) => addDollars(sum, item), 0);
}

export function dollarSumBy<T>(dollars: T[], func: (item: T) => number): number {
  return dollars.reduce((sum, item) => addDollars(sum, func(item)), 0);
}

// Find out your COGS (cost of goods sold). For example $30.
// Find out your revenue (how much you sell these goods for, for example $50).
// Calculate the gross profit by subtracting the cost from the revenue. $50 - $30 = $20
// Divide gross profit by revenue: $20 / $50 = 0.4.
// Express it as percentages: 0.4 * 100 = 40%.
export function calcProfitMargin(cogsDollars: number, revenueDollars: number) {
  if (!revenueDollars) {
    return 0;
  }
  const cost = toCents(cogsDollars);
  const revenue = toCents(revenueDollars);
  const profit = revenue - cost;
  const grossProfit = profit / revenue;

  return grossProfit * 100;
}

export function calcSalesPriceForMargin(cogsDollars: number, marginPercentage: number) {
  if (marginPercentage >= 100) {
    throw new Error('marginPercentage must be below 100');
  }
  const cogsCents = toCents(cogsDollars);
  const margin = marginPercentage / 100;
  return toDollars(cogsCents/(1 - margin));
}
